import React, { useEffect } from 'react';

// Import Toastify
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//import Scss
import './assets/scss/themes.scss';
import 'remixicon/fonts/remixicon.css';

//imoprt Route
import Route from './Routes';

// Import Firebase Configuration file
// import { initFirebaseBackend } from "./helpers/firebase_helper";

// Fackbackend
import fakeBackend from './helpers/AuthType/fakeBackend';

// Import Socket initialization
import { initSocket } from './helpers/socket';

// Activating fake backend
fakeBackend();

function App() {
  useEffect(() => {
    // Initialize Socket Connection
    const socket = initSocket();

    return () => {
      // Disconnect socket on unmount
      socket.disconnect();
    };
  }, []);

  return (
    <React.Fragment>
      <Route />
      <ToastContainer autoClose={2000} limit={1} />
    </React.Fragment>
  );
}

export default App;

